var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.printMode)?_c('img',{staticClass:"ui fluid image",attrs:{"src":_vm.image,"title":_vm.label}}):_c('div',{ref:"widget"})])}
var staticRenderFns = []

export { render, staticRenderFns }